/**
 * Enums for billing payment frequencies.
 */
export enum PaymentFrequency {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  ANNUAL = 'ANNUAL'
}